/*
 * TracePrecision Chargen-Panel (PDP-Accordion "Labor & Transparenz").
 *
 * Liest die oeffentliche View v_tp_lots (Supabase-Projekt attribution_tool)
 * mit dem Anon-Key — dieselbe Quelle, die traceprecision.com ausliest.
 * Geladen wird ERST beim Aufklappen des Accordions, damit die PDP keine
 * zusaetzliche Anfrage im Seitenaufbau bekommt.
 *
 * Chargen haengen an der SKU, nicht am Produkt: beim Variantenwechsel
 * (Theme feuert ein bubbelndes 'change' auf input[name="id"], siehe
 * assets/product.js -> updateVariantInput) wird die Charge neu geladen.
 *
 * Faellt bei jedem Fehler auf einen Hinweis + Link zu TracePrecision
 * zurueck — das Accordion bleibt nie leer.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('tp-lot-panel')) return;

  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var DOWNLOAD = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
  var TIMEOUT_MS = 8000;

  function esc(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* i18n-Wert aus einer _i18n-Map ziehen: Sprache -> en -> de -> Rohwert */
  function pick(map, fallback, lang) {
    if (map && typeof map === 'object' && !Array.isArray(map)) {
      if (map[lang]) return map[lang];
      if (map.en) return map.en;
      if (map.de) return map.de;
    }
    return fallback || '';
  }

  /* "A" + " · " + "B", leere Teile fallen weg */
  function dot(parts) {
    return parts.filter(Boolean).join(' \u00b7 ');
  }

  function row(item) {
    if (!item.value) return '';
    var logo = item.logo
      ? '<img class="tp-lot__rowlogo" src="' + esc(item.logo) + '" alt="' + esc(item.logoAlt || '') + '" loading="lazy">'
      : '';
    return '<div class="tp-lot__row"><span class="tp-lot__row-label">' + esc(item.label) + '</span>' +
      '<span class="tp-lot__row-value">' + logo + esc(item.value) + '</span></div>';
  }

  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    } catch (e) { /* Tracking darf das Panel nie brechen */ }
  }

  function parseFallbackMap(raw) {
    var map = {};
    if (!raw) return map;
    String(raw).split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) {
        var from = parts[0].trim();
        var to = parts[1].trim();
        if (from && to) map[from] = to;
      }
    });
    return map;
  }

  class TpLotPanel extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      var configEl = this.querySelector('script[type="application/json"][data-tp-config]');
      if (!configEl) return;
      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      this.body = this.querySelector('[data-tp-body]');
      if (!this.body) return;

      this.lang = (this.config.lang || 'de').toLowerCase();
      this.labels = this.config.labels || {};
      this.skuFallback = parseFallbackMap(this.config.skuFallback);
      this.variantSkus = this.config.variantSkus || {};
      this.currentSku = this.config.sku || '';
      this.listCache = null;
      this.detailCache = {};
      this.loaded = false;

      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('change', this.onVariantChange);

      var details = this.closest('details');
      if (details) {
        this.details = details;
        if (details.open) {
          this.load();
        } else {
          this.onToggle = function () {
            if (details.open) this.load();
          }.bind(this);
          details.addEventListener('toggle', this.onToggle);
        }
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      if (this.details && this.onToggle) this.details.removeEventListener('toggle', this.onToggle);
    }

    onVariantChange(event) {
      var target = event.target;
      if (!target || !target.matches || !target.matches('input[name="id"]')) return;
      var sku = this.variantSkus[String(target.value)];
      if (!sku || sku === this.currentSku) return;
      this.currentSku = sku;
      if (this.loaded || (this.details && this.details.open)) this.load();
    }

    request(query) {
      var controller = ('AbortController' in window) ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
      return fetch(this.config.endpoint + '?' + query, {
        headers: { apikey: this.config.key, accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (timer) window.clearTimeout(timer);
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      });
    }

    load() {
      var self = this;
      var sku = this.currentSku;
      var token = (this.token || 0) + 1;
      this.token = token;
      this.loaded = true;

      if (!this.hasRendered) this.renderLoading();

      var listPromise = this.listCache
        ? Promise.resolve(this.listCache)
        : this.request('brand_or_product=eq.' + encodeURIComponent(this.config.brand) +
            '&select=lot_number,product_sku,batch_date,slug&order=batch_date.desc,lot_number.desc');

      listPromise.then(function (list) {
        if (self.token !== token) return null;
        self.listCache = list;

        var lookupSku = sku;
        var row = self.pickRow(list, lookupSku);
        if (!row && self.skuFallback[lookupSku]) {
          row = self.pickRow(list, self.skuFallback[lookupSku]);
        }
        if (!row) {
          self.renderError(list.length);
          return null;
        }
        if (self.detailCache[row.slug]) return { detail: self.detailCache[row.slug], total: list.length };

        return self.request('slug=eq.' + encodeURIComponent(row.slug) +
          '&select=lot_number,batch_date,best_before,lab_report_url,registration_number,raw_material_origin,capsule_shell,manufacturer,packaging&limit=1'
        ).then(function (rows) {
          if (!rows || !rows.length) throw new Error('lot not found');
          self.detailCache[row.slug] = rows[0];
          return { detail: rows[0], total: list.length };
        });
      }).then(function (result) {
        if (!result || self.token !== token) return;
        self.render(result.detail, result.total);
      }).catch(function () {
        if (self.token !== token) return;
        self.renderError(0);
      });
    }

    pickRow(list, sku) {
      if (!Array.isArray(list) || !sku) return null;
      for (var i = 0; i < list.length; i++) {
        if (list[i].product_sku === sku) return list[i];
      }
      return null;
    }

    historyLink(total) {
      var label = this.labels.history_cta || '';
      var count = '';
      if (total > 0) {
        var pattern = total === 1 ? (this.labels.history_count_one || '') : (this.labels.history_count_other || '');
        count = pattern.replace('{count}', total);
      }
      return '<a class="tp-lot__history" href="' + esc(this.config.historyUrl) + '" target="_blank" rel="noopener" data-tp-history>' +
        '<span>' + esc(label) + '</span>' +
        (count ? '<span class="tp-lot__history-count">' + esc(count) + '</span>' : '') +
        ARROW +
        '</a>';
    }

    renderLoading() {
      this.body.setAttribute('aria-busy', 'true');
      this.body.innerHTML = '<div class="tp-lot__skeleton" role="status" aria-label="' + esc(this.labels.loading || '') + '">' +
        '<span></span><span></span><span></span></div>';
    }

    renderError(total) {
      this.hasRendered = true;
      this.body.setAttribute('aria-busy', 'false');
      this.body.innerHTML = '<p class="tp-lot__state">' + esc(this.labels.error || '') + '</p>' +
        this.historyLink(total || 0);
      this.bindTracking();
    }

    /* Aus der Charge die Herkunfts-Zeilen bauen.
       Produktions- und MHD-Datum werden bewusst NICHT gezeigt (Daniel,
       2026-09-23) — die Chargennummer steht oben im Kopf, den Rest
       liefert die Chargenseite auf TracePrecision. */
    prepare(lot) {
      var lang = this.lang;
      var l = this.labels;
      var rows = [];

      (Array.isArray(lot.raw_material_origin) ? lot.raw_material_origin : []).forEach(function (item) {
        rows.push({
          label: l.ingredient,
          value: dot([
            pick(item.ingredient_i18n, item.ingredient, lang),
            pick(item.origin_i18n, item.origin, lang)
          ])
        });
      });

      var cap = lot.capsule_shell;
      if (cap && (cap.material || cap.origin || cap.supplier)) {
        /* Vcaps-Bildmarke nur, wenn die Charge wirklich Vcaps ist.
           Die View liefert zwei Schreibweisen ("HPMC V-Caps Plus" und
           "Vcaps(R) von Lonza Capsugel: ..."), aeltere Chargen laufen
           auf "HPMC Kapselhuelle" und bekommen kein Logo. */
        var capsuleRow = {
          label: l.capsule,
          value: dot([
            pick(cap.material_i18n, cap.material, lang),
            pick(cap.origin_i18n, cap.origin, lang),
            pick(cap.supplier_i18n, cap.supplier, lang)
          ])
        };
        if (this.config.capsuleLogoUrl && /v-?caps/i.test(cap.material || '')) {
          capsuleRow.logo = this.config.capsuleLogoUrl;
          capsuleRow.logoAlt = 'Vcaps';
        }
        rows.push(capsuleRow);
      }

      /* Abfuellung: nur das Land. Die Zertifizierungen (GMP, IFS Food,
         HACCP, Bio, ISO 9001) werden hier bewusst NICHT gezeigt
         (Daniel, 2026-09-23) — sie stehen vollstaendig auf der
         Chargenseite von TracePrecision, verlinkt am Fuss des Panels. */
      var mfg = lot.manufacturer;
      if (mfg && mfg.country) {
        rows.push({ label: l.filling, value: pick(mfg.country_i18n, mfg.country, lang) });
      }

      var packaging = Array.isArray(lot.packaging) ? lot.packaging : [];
      if (packaging.length) {
        var names = [], origins = [];
        packaging.forEach(function (item) {
          var name = pick(item.component_i18n, item.component, lang);
          var from = pick(item.origin_i18n, item.origin, lang);
          if (name) names.push(name);
          if (from && origins.indexOf(from) === -1) origins.push(from);
        });
        rows.push({ label: l.packaging, value: dot([names.join(', '), origins.join(', ')]) });
      }

      /* Doppelte Zeilen zusammenfassen: eine Charge kann aus mehreren
         Lieferantenchargen desselben Rohstoffs abgefuellt sein. Deren
         Nummern sind bewusst nicht oeffentlich (Migration 132), also
         bleiben sonst zwei identische "Wirkstoff"-Zeilen stehen. */
      var gesehen = {};
      return rows.filter(function (r) {
        var key = r.label + '\u0000' + r.value;
        if (gesehen[key]) return false;
        gesehen[key] = true;
        return true;
      });
    }

    head(lot) {
      var reg = lot.registration_number || this.config.reg;
      var l = this.labels;
      var html = '<div class="tp-lot__head">';
      if (this.config.sealUrl) {
        html += '<img class="tp-lot__seal" src="' + esc(this.config.sealUrl) + '" alt="" loading="lazy" width="44" height="44">';
      }
      return html + '<div><div class="tp-lot__eyebrow"><span class="tp-lot__dot"></span>TracePrecision' +
        (reg ? ' &middot; ' + esc((l.registration || '') + ' TP-' + reg) : '') +
        '</div><div class="tp-lot__title">' + esc(l.current_batch || '') + '</div>' +
        '<div class="tp-lot__lot tp-lot__mono">' + esc(lot.lot_number) + '</div></div></div>';
    }

    reportLink(lot) {
      var l = this.labels;
      if (!lot.lab_report_url) return '<p class="tp-lot__noreport">' + esc(l.no_report || '') + '</p>';
      return '<a class="tp-lot__pdf" href="' + esc(lot.lab_report_url) + '" target="_blank" rel="noopener" data-tp-report>' +
        DOWNLOAD + '<span>' + esc(l.lab_report || '') + '</span></a>';
    }

    render(lot, total) {
      var l = this.labels;
      var html = this.head(lot);

      html += '<div class="tp-lot__rows">';
      this.prepare(lot).forEach(function (r) { html += row(r); });
      html += '</div>';

      html += this.reportLink(lot);
      if (l.note) html += '<p class="tp-lot__note">' + esc(l.note) + '</p>';
      html += this.historyLink(total);

      this.hasRendered = true;
      this.body.setAttribute('aria-busy', 'false');
      this.body.innerHTML = html;
      this.bindTracking();
      track('tp_lot_panel_view', {
        tp_brand: this.config.brand,
        tp_lot: lot.lot_number,
        tp_sku: this.currentSku
      });
    }

    bindTracking() {
      var self = this;
      var report = this.body.querySelector('[data-tp-report]');
      if (report) {
        report.addEventListener('click', function () {
          track('tp_lab_report_click', { tp_brand: self.config.brand, tp_sku: self.currentSku, cta_url: report.href });
        });
      }
      var history = this.body.querySelector('[data-tp-history]');
      if (history) {
        history.addEventListener('click', function () {
          track('tp_lot_history_click', { tp_brand: self.config.brand, tp_sku: self.currentSku, cta_url: history.href });
        });
      }
    }
  }

  customElements.define('tp-lot-panel', TpLotPanel);
})();
